module.exports = __webpack_public_path__ + "static/media/tarra-logotype-d.2e31b16e.svg";